import { useState, useEffect, RefObject, useCallback } from 'react'
import { IPositionParams } from '../grid.types'
import gridLayoutConstants from '../gridLayout.constants'

const usePositionParams = (
  containerRef: RefObject<HTMLDivElement>,
  initIPositionParams: IPositionParams,
  onColsParamChanged: (cols: number) => void
) => {
  const [positionParams, setPositionParams] = useState<IPositionParams>(initIPositionParams)

  const updateWidth = useCallback(() => {
    if (!containerRef.current) return
    const { width } = containerRef.current.getBoundingClientRect()
    const newPosParams = { ...positionParams }

    const newColValue = getUpdateColValue(width)
    if (newColValue !== positionParams.cols) {
      newPosParams.cols = newColValue
      onColsParamChanged(newColValue)
    }

    setPositionParams({ ...newPosParams, containerWidth: width })
  }, [containerRef])

  const getUpdateColValue = (width: number) => {
    if (width <= 1280) {
      return gridLayoutConstants.colByScreenWidth[1280]
    } else {
      return gridLayoutConstants.colByScreenWidth[1920]
    }
  }

  useEffect(() => {
    const observer = new ResizeObserver(updateWidth)
    if (containerRef.current) observer.observe(containerRef.current)
    return () => observer.disconnect()
  }, [containerRef])

  return {
    positionParams,
  }
}

export default usePositionParams
